import {
  NotificationIcon as CoreNotificationIcon,
  useSession,
} from '@zhiyue/core';
import React from 'react';
import { getOpenPlatformToken } from '@/services/bff/openPlatform.api';
import { hasOAuth2Session } from '@/services/oauth2';

type NotificationIconProps = Omit<
  React.ComponentProps<typeof CoreNotificationIcon>,
  'token'
>;

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { currentUser, loading } = useSession();
  const [token, setToken] = React.useState<string>();

  React.useEffect(() => {
    if (loading || !currentUser?.memberUuid || !hasOAuth2Session()) {
      setToken(undefined);
      return;
    }

    let active = true;
    getOpenPlatformToken()
      .then(({ accessToken }) => {
        if (active) {
          setToken(accessToken);
        }
      })
      .catch(() => {
        if (active) {
          setToken(undefined);
        }
      });

    return () => {
      active = false;
    };
  }, [currentUser?.memberUuid, loading]);

  if (loading || !currentUser?.memberUuid || !token) {
    return null;
  }

  return <CoreNotificationIcon {...props} token={token} />;
};

export default NotificationIcon;
